module.exports = __webpack_public_path__ + "static/media/effect_anim_237_sparkle.0590ed0c.wav";